var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "infinite-scroll",
          rawName: "v-infinite-scroll",
          value: function() {
            return _vm.$emit("fetch-more-data")
          },
          expression: "() => $emit('fetch-more-data')"
        }
      ],
      attrs: {
        "submissions-problem": "",
        "infinite-scroll-disabled": "isScrollDisabled",
        "infinite-scroll-distance": "10"
      }
    },
    [
      _c("div", { staticClass: "text-center mb-5 submissions-title" }, [
        _c("h2", [_vm._v(" " + _vm._s(_vm.T.submissionsListTitle) + " ")]),
        !_vm.includeUser && _vm.submissions.length > 0
          ? _c(
              "h4",
              [
                _vm._v(" " + _vm._s(_vm.T.wordsBy) + " "),
                _c("omegaup-username", {
                  attrs: {
                    username: _vm.submissions[0].username,
                    classname: _vm.submissions[0].classname,
                    linkify: true
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "card" }, [
        _vm.includeUser
          ? _c(
              "div",
              { staticClass: "card-body d-flex align-items-center" },
              [
                _c("omegaup-common-typeahead", {
                  staticClass: "mr-2",
                  attrs: {
                    "existing-options": _vm.searchResultUsers,
                    value: _vm.searchedUsername,
                    "max-results": 10
                  },
                  on: {
                    "update:value": function($event) {
                      _vm.searchedUsername = $event
                    },
                    "update-existing-options": function(query) {
                      return _vm.$emit("update-search-result-users", query)
                    }
                  }
                }),
                _c("a", { attrs: { href: _vm.hrefSearchUser } }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" }
                    },
                    [_vm._v(" " + _vm._s(_vm.T.searchUser) + " ")]
                  )
                ])
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "table-responsive" }, [
          _c("table", { staticClass: "table mb-0 submissions-table" }, [
            _c("thead", [
              _c("tr", [
                _c(
                  "th",
                  { staticClass: "text-center", attrs: { scope: "col" } },
                  [_vm._v(_vm._s(_vm.T.wordsTime))]
                ),
                _vm.includeUser
                  ? _c(
                      "th",
                      { staticClass: "text-center", attrs: { scope: "col" } },
                      [_vm._v(" " + _vm._s(_vm.T.submissionsListCoder) + " ")]
                    )
                  : _vm._e(),
                _c(
                  "th",
                  { staticClass: "text-center", attrs: { scope: "col" } },
                  [_vm._v(_vm._s(_vm.T.wordsProblem))]
                ),
                _c(
                  "th",
                  {
                    staticClass: "text-center",
                    class: { "fixed-width-column": _vm.includeUser },
                    attrs: { scope: "col" }
                  },
                  [_vm._v(" " + _vm._s(_vm.T.wordsLanguage) + " ")]
                ),
                _c(
                  "th",
                  {
                    staticClass: "text-center fixed-with-column",
                    attrs: { scope: "col" }
                  },
                  [_vm._v(" " + _vm._s(_vm.T.wordsVerdict) + " ")]
                ),
                _c(
                  "th",
                  { staticClass: "text-right", attrs: { scope: "col" } },
                  [_vm._v(_vm._s(_vm.T.wordsRuntime))]
                ),
                _c(
                  "th",
                  { staticClass: "text-right", attrs: { scope: "col" } },
                  [_vm._v(_vm._s(_vm.T.wordsMemory))]
                )
              ])
            ]),
            _c(
              "tbody",
              [
                _vm._l(_vm.submissions, function(submission) {
                  return _c("tr", { key: submission.guid }, [
                    _c("td", { staticClass: "text-center" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.time.formatDateTime(submission.time)) +
                          " "
                      )
                    ]),
                    _vm.includeUser
                      ? _c(
                          "td",
                          { staticClass: "text-center" },
                          [
                            _c("omegaup-username", {
                              attrs: {
                                username: submission.username,
                                classname: submission.classname,
                                linkify: true
                              }
                            }),
                            _c("br"),
                            _c(
                              "a",
                              {
                                staticClass: "school-text",
                                attrs: {
                                  href:
                                    "/schools/profile/" +
                                    submission.school_id +
                                    "/"
                                }
                              },
                              [_vm._v(_vm._s(submission.school_name))]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("td", { staticClass: "text-center" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "/arena/problem/" + submission.alias + "/"
                          }
                        },
                        [_vm._v(_vm._s(submission.title))]
                      )
                    ]),
                    _c("td", { staticClass: "text-center" }, [
                      _vm._v(_vm._s(submission.language))
                    ]),
                    _c(
                      "td",
                      {
                        staticClass: "text-center verdict",
                        class: "verdict-" + submission.verdict
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.T["verdict" + submission.verdict]) +
                            " "
                        )
                      ]
                    ),
                    _c("td", { staticClass: "text-center" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            submission.runtime === 0
                              ? "—"
                              : _vm.ui.formatString(
                                  _vm.T.submissionRunTimeInSeconds,
                                  {
                                    value: (
                                      parseFloat(submission.runtime || "0") /
                                      1000
                                    ).toFixed(2)
                                  }
                                )
                          ) +
                          " "
                      )
                    ]),
                    _c("td", { staticClass: "text-center" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            submission.memory === 0
                              ? "—"
                              : _vm.ui.formatString(
                                  _vm.T.submissionMemoryInMegabytes,
                                  {
                                    value: (
                                      parseFloat(submission.memory) /
                                      (1024 * 1024)
                                    ).toFixed(2)
                                  }
                                )
                          ) +
                          " "
                      )
                    ])
                  ])
                }),
                _vm.loading
                  ? _vm._l(3, function(index) {
                      return _c("tr", { key: index }, [_vm._m(0, true)])
                    })
                  : _vm._e()
              ],
              2
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "16" } }, [
      _c("div", { staticClass: "line" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }